<template>
  <div class="chart5">
    <div id="Chart5" style="width: 125px; height: 250px"></div>
    <div id="Chart52" style="width: 125px; height: 250px"></div>
    <div id="Chart53" style="width: 125px; height: 250px"></div>
    <div id="Chart54" style="width: 125px; height: 250px"></div>
    <div class="chart5_table">
      <div>
        <table border="1" cellspacing="0">
          <tr>
            <th>ROE(TTM)</th>
            <th>销售净利率</th>
            <th>总资产周转率</th>
            <th>权益乘数</th>
          </tr>
          <tr>
            <td colspan="4">
              <i class="i1">{{chart5_data_y[2]}}%</i> ≈ <i class="i1">{{chart5_data_y[3]}}%</i> ×
              <i class="i1">{{chart5_data_y[0]}}</i> × <i class="i1">{{chart5_data_y[1]}}</i>
            </td>
          </tr>
          <tr>
            <td colspan="4">
              <i class="i2">{{chart5_data_y2[2]}}%</i> ≈ <i class="i2">{{chart5_data_y2[3]}}%</i> ×
              <i class="i2">{{chart5_data_y2[0]}}</i> × <i class="i2">{{chart5_data_y2[1]}}</i>
            </td>
          </tr>
        </table>
      </div>
      <div style="margin-top: 10px; font-size: 17px; color: #999999">
        <img
          style="
            width: 15px;
            height: 15px;
            vertical-align: middle;
            cursor: pointer;
          "
          src="../../../../public/img/shares_Info/yiwen.png"
          alt=""
        />
        点击查看为什么是“≈”
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props:{
    chart5_data_y:{
      type:Array,
      default(){
        return []
      }
    },
    chart5_data_y2:{
      type:Array,
      default(){
        return []
      }
    }
  },
  methods: {
    myEcharts5() {
      var myChart5 = this.$echarts.init(document.getElementById("Chart5"));
      //配置图表
      var option5 = {
        grid: {
          containLabel: true,
          left: -20,
          right: 0,
          bottom: 20,
          top: 20,
        },
        xAxis: {
          axisTick: {
            show: false,
            lineStyle: {
              width: "30",
            },
          },
          axisLine: {
            lineStyle: {
              color: "#ededed",
            },
          },
          data: ["ROE"],
          axisLabel: {
            formatter: function (e) {
              return `{a| ${e}}`;
            },
            rich: {
              a: {
                color:'#000'
              },
             
            },
          },
           offset:10,
        },
        yAxis: {
          type: "value",
          show: false,
        },
        series: [
          {
            name: "格力电器",
            type: "bar",
            barGap: "100%",
            data: [this.chart5_data_y[3]],
            color: "#539cff",
            barWidth: 20,
            label: {
              formatter: "{c}%",
              show: true,
              position: "top",
              color: "#539cff",
            },
          },
          {
            name: "白色家电",
            type: "bar",
            barGap: "100%",
            data: [this.chart5_data_y2[3]],
            color: "#fcad2a",
            barWidth: 20,
          },
        ],
      };
      myChart5.setOption(option5);
    },
    myEcharts52() {
      var myChart52 = this.$echarts.init(document.getElementById("Chart52"));
      //配置图表
      var option52 = {
        grid: {
          containLabel: true,
          left: -22,
          right: 0,
          bottom: 20,
          top: 20,
        },
        xAxis: {
          axisTick: {
            show: false,
            lineStyle: {
              width: "30",
            },
          },
          axisLine: {
            lineStyle: {
              color: "#ededed",
            },
          },
          data: ["销售净利率"],
          axisLabel: {
            formatter: function (e) {
              return `{a|${e}}`;
            },
            rich: {
              a: {
                color:'#000'
              },
             
            },
          },
           offset:10,
        },
        yAxis: {
          type: "value",
          show: false,
        },
        series: [
          {
            name: "格力电器",
            type: "bar",
            barGap: "100%",
            data: [this.chart5_data_y[2]],
            color: "#539cff",
            barWidth: 20,
            label: {
              formatter: "{c}%",
              show: true,
              position: "top",
              color: "#539cff",
            },
          },
          {
            name: "白色家电",
            type: "bar",
            barGap: "100%",
            data: [this.chart5_data_y2[2]],
            color: "#fcad2a",
            barWidth: 20,
          },
        ],
      };
      myChart52.setOption(option52);
    },
    myEcharts53() {
      var myChart53 = this.$echarts.init(document.getElementById("Chart53"));
      //配置图表
      var option53 = {
        grid: {
          containLabel: true,
          left: -35,
          right: 0,
          bottom: 20,
          top: 20,
        },
        xAxis: {
          axisTick: {
            show: false,
            lineStyle: {
              width: "30",
            },
          },
          axisLine: {
            lineStyle: {
              color: "#ededed",
            },
          },
          data: ["总资产周转率"],
          axisLabel: {
            formatter: function (e) {
              return `{a|${e}}`;
            },
            rich: {
              a: {
                color:'#000'
              },
             
            },
          },
           offset:10,
        },
        yAxis: {
          type: "value",
          show: false,
        },
        series: [
          {
            name: "格力电器",
            type: "bar",
            barGap: "100%",
            data: [this.chart5_data_y[0]],
            color: "#539cff",
            barWidth: 20,
            label: {
              formatter: "{c}",
              show: true,
              position: "top",
              color: "#539cff",
            },
          },
          {
            name: "白色家电",
            type: "bar",
            barGap: "100%",
            data: [this.chart5_data_y2[0]],
            color: "#fcad2a",
            barWidth: 20,
          },
        ],
      };
      myChart53.setOption(option53);
    },
    myEcharts54() {
      var myChart54 = this.$echarts.init(document.getElementById("Chart54"));
      //配置图表
      var option54 = {
        grid: {
          containLabel: true,
          left: -25,
          right: 0,
          bottom: 20,
          top: 20,
        },
        xAxis: {
          axisTick: {
            show: false,
            lineStyle: {
              width: "30",
            },
          },
          axisLine: {
            lineStyle: {
              color: "#ededed",
            },
          },
          offset:10,
          data: ["权益乘数"],
          axisLabel: {
            formatter: function (e) {
              return `{a|${e}}`;
            },
            rich: {
              a: {
                color:'#000'
              },
             
            },
          },
        },
        yAxis: {
          type: "value",
          show: false,
        },
        series: [
          {
            name: "格力电器",
            type: "bar",
            barGap: "100%",
            data: [this.chart5_data_y[1]],
            color: "#539cff",
            barWidth: 20,
            label: {
              formatter: "{c}",
              show: true,
              position: "top",
              color: "#539cff",
            },
          },
          {
            name: "白色家电",
            type: "bar",
            barGap: "100%",
            data: [this.chart5_data_y2[1]],
            color: "#fcad2a",
            barWidth: 20,
          },
        ],
      };
      myChart54.setOption(option54);
    },
    init(){
      this.myEcharts5();
      this.myEcharts52();
      this.myEcharts53();
      this.myEcharts54();
    }
  },
  mounted() {
      this.myEcharts5();
      this.myEcharts52();
      this.myEcharts53();
      this.myEcharts54();
  },
};
</script>

<style scoped>
.chart5 {
  display: flex;
  flex-direction: row;
}
table {
  border-color: #f4f4f4;
  border-collapse: collapse;
}
th,
td {
  width: 110px;
  height: 43px;
  text-align: center;
}
.chart5_table {
  display: flex;
  flex-direction: column;
  justify-content: end;
  margin-left: 100px;
}
th {
  font-size: 16px;
  color: #333333;
  font-weight: 400;
}
.i1 {
  font-style: normal;
  color: #539cff;
}
.i2 {
  font-style: normal;
  color: #fcad2a;
}
</style>